<div class="modal" *transloco="let t; read:'permit.gasfreeCert.materialInfoModal'">
    <div class="modal__content">
        <div class="modal__heading">{{ t("title", { materialName: data.material.name }) }}</div>

        <div class="modal__details">
            <div class="modal__details__row">
                <div class="modal__details__row__label">{{ t("fields.casNumber") }}</div>
                <div class="modal__details__row__value">{{ displayValue(data.material.cas) }}</div>
            </div>
            <div class="modal__details__row">
                <div class="modal__details__row__label">{{ t("fields.unNumber") }}</div>
                <div class="modal__details__row__value">{{ displayValue(data.material.unNumber) }}</div>
            </div>
            <div class="modal__details__row">
                <div class="modal__details__row__label">{{ t("fields.class") }}</div>
                <div class="modal__details__row__value">{{ displayValue(data.material.class) }}</div>
            </div>
            <div class="modal__details__row">
                <div class="modal__details__row__label">{{ t("fields.hazardNumber") }}</div>
                <div class="modal__details__row__value">{{ displayValue(data.material.hazardNumber) }}</div>
            </div>
            <div class="modal__details__row">
                <div class="modal__details__row__label">{{ t("fields.packingGroup") }}</div>
                <div class="modal__details__row__value">{{ displayValue(data.material.packingGroup) }}</div>
            </div>
        </div>

        <div *ngIf="hasValue(data.material.matchedSynonym)" class="modal__synonyms">
            <div class="modal__synonyms__heading">{{ t("fields.synonyms") }}</div>
            <div class="modal__synonyms__value">{{ data.material.matchedSynonym }}</div>
        </div>
    </div>

    <div class="modal__actions">
        <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("close") }}</button>
    </div>
</div>
